import React from "react";
import { footerLinks } from "../data/mockData";
import { LayoutGrid, Twitter, Linkedin, Youtube } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t border-white/[0.05] pt-16 pb-8">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-16">
          {/* Logo Column */}
          <div className="col-span-2 md:col-span-1">
            <a href="/" className="flex items-center gap-2.5 mb-5 group">
              <div className="w-7 h-7 rounded-md bg-white flex items-center justify-center">
                <LayoutGrid size={14} className="text-black" />
              </div>
              <span className="text-white font-semibold text-base tracking-tight">AllSave</span>
            </a>
            <p className="text-[#444] text-[13px] leading-relaxed mb-6">
              Your personal ad inspiration library.
              Save, organize, and find creative ideas — fast.
            </p>
            <div className="flex items-center gap-2.5">
              {[Twitter, Linkedin, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-8 h-8 rounded-lg bg-white/[0.03] border border-white/[0.06] flex items-center justify-center text-[#444] hover:text-white/70 hover:border-white/[0.12] transition-all duration-300"
                >
                  <Icon size={13} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-[11px] text-[#555] uppercase tracking-[0.15em] font-medium mb-5">
                {category}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-[13px] text-[#555] hover:text-white/70 transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/[0.05] pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#333] text-[12px]">
            &copy; {new Date().getFullYear()} AllSave. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-[#333] hover:text-[#666] text-[12px] transition-colors">Privacy</a>
            <a href="#" className="text-[#333] hover:text-[#666] text-[12px] transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
